import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {finalize} from 'rxjs/operators';
import {environment} from '../../environments/environment';
import {BaseService} from "../../../../shared/src/lib/services/base.service";
import {DynamicModalComponent} from '../../../../shared/src/lib/modals/dynamic-modal/dynamic-modal.component';
import {GroupReviewModalComponent} from './routing-review/routing-review.component';

@Injectable({
  providedIn: 'root'
})
export class ReviewService extends BaseService {
  private __current_search_obj = {
    content_type: null,
    record_id: null,
    group_review: null,
    is_in_group: null,
    submission_date__gte: null,
    submission_date__lte: null,
    approved_date__gte: null,
    approved_date__lte: null,
  };
  public meta: {[key: string]: any} = {
    verbose_name_plural: 'Routing/Review',
    verbose_name: 'Review',
    display_fields: ['reviewer', 'status', 'reason', 'order', 'last_edited_date', 'submission_date', 'approved_date'],
    type: 'review',
    approve_value: 'approved',
    reject_value: 'rejected',
    isLoading: false,
    fields: {
      status: {
        get_choices: (item) => {
          const choices = item.approve_allowed===false?this.meta.fields.status.choices.filter(x => x.value !== 'approved'):this.meta.fields.status.choices;
          return Promise.resolve(choices)
        }
      },
      sub_type: {
        get_choices: (item) => {
          return Promise.resolve(this.meta.permit_subtypes)
        }
      }
    }
  };
  loading: boolean;

  public isLoading: boolean;

  constructor(http: HttpClient, private modalService: NgbModal) {
    super(`${environment.baseUrl}/review`, http);
  }

  public setCurrentFilter(content_type, record_id, group_review, submission_date__gte?, submission_date__lte?, approved_date__gte?, approved_date__lte?) {
    this.__current_search_obj.content_type = content_type;
    this.__current_search_obj.record_id = record_id;
    this.__current_search_obj.group_review = group_review;
    this.__current_search_obj.is_in_group = group_review !== undefined;

    if (this.__current_search_obj.hasOwnProperty('submission_date__gte') && submission_date__gte) {
      this.__current_search_obj.submission_date__gte = submission_date__gte.toISOString();
    }
    if (this.__current_search_obj.hasOwnProperty('submission_date__lte') && submission_date__lte) {
      this.__current_search_obj.submission_date__lte = submission_date__lte.toISOString();
    }
    if (this.__current_search_obj.hasOwnProperty('approved_date__gte') && approved_date__gte) {
      this.__current_search_obj.approved_date__gte = approved_date__gte.toISOString();
    }
    if (this.__current_search_obj.hasOwnProperty('approved_date__lte') && approved_date__lte) {
      this.__current_search_obj.approved_date__lte = approved_date__lte.toISOString();
    }
  }

  // public load_metadata() {
  //   if (!this.meta.hasOwnProperty('fields')) {
  //     if (!this.meta.isLoading) {
  //       this.meta.isLoading = true;
  //       this.get('metadata').subscribe(metadata => {
  //         merge(this.meta, metadata);
  //         this.meta.isLoading = false;
  //       });
  //     }
  //   }
  // }

  public open_modal(foreignKey, item) {
    let modalInstance;
    if (item.is_group) {
      modalInstance = this.modalService.open(GroupReviewModalComponent, {backdrop: 'static', size: 'lg'});
      modalInstance.componentInstance.item = item;
      modalInstance.componentInstance.meta = this.meta;
    } else {
      // item.reasons = [];
      // item._reason = item.reason;
      // Object.defineProperty(item, 'reason', {
      //   get: function () {
      //     return this._reason;
      //   },
      //   set: function (input) {
      //     item._reason = input;
      //     item.reasons.push(input);
      //   }
      // });


      if (Object.keys(item).length === 0) {
        item.record_id = this.__current_search_obj.record_id;
        item.content_type = this.__current_search_obj.content_type;
        item.group_review = this.__current_search_obj.group_review;
      }

      if (item.id !== undefined) {
        item.globalid = item.id;
        if (!this.meta.permissions.write) {
          this.meta.fields.reviewer.read_only = true;
          this.meta.fields.order.read_only = true;
        }
      } else if (!this.meta.permissions.write) {
        this.meta.fields.reviewer.read_only = false;
        this.meta.fields.order.read_only = false;
      }

      modalInstance = this.modalService.open(DynamicModalComponent, {backdrop: 'static', size: 'lg'});
      modalInstance.componentInstance.item = item;
      modalInstance.componentInstance.meta = this.meta;
    }
    return modalInstance.result;
  }

  public get_items() {
    this.loading = true;
    this.getList(this.__current_search_obj).pipe(finalize(() => this.loading = false));
  }

}
